import { render, staticRenderFns } from "./CargaFamiliar.vue?vue&type=template&id=19b5c834"
import script from "./CargaFamiliar.js?vue&type=script&lang=js&external"
export * from "./CargaFamiliar.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports